import { IRepresentativeClient } from "../../interfaces/models/IRepresentativeClient";


  export const emptyRepresentativeClient: IRepresentativeClient = {
    id: '',
    name: '',
    firm: '',
    office: '',
  }